var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spacer-h16-container",class:_vm.rootClassName})}
var staticRenderFns = []

export { render, staticRenderFns }